import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetNavigationHeaderResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import React from 'react';
import {FilterAndSortFABView} from '../../../../features/Filters/FilterAndSort/FilterAndSortFABView';
import {useHeaderData} from '../../Header/helpers';

interface FilterAndSortProps {
  label: string;
}

export const FilterAndSort: React.FC<FilterAndSortProps> = ({label}) => {
  return (
    <DataFetcher
      request={useHeaderData()}
      Error={null}
      View={FilterAndSortView}
      viewProps={{label}}
    />
  );
};

const FilterAndSortView: React.FC<
  GetNavigationHeaderResponse & {label: string}
> = ({appliedFiltersCount, hideFiltersEntry, label}) => {
  if (hideFiltersEntry) {
    return null;
  }
  return <FilterAndSortFABView count={appliedFiltersCount} label={label} />;
};
